// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lz-tag {\n  width: 68px;\n  height: 28px;\n  display: inline-block;\n  line-height: 28px;\n  border-radius: 14px;\n  text-align: center;\n}\n.lz-tag__dot {\n  width: auto;\n  height: auto;\n  line-height: 1;\n  text-align: left;\n}\n.lz-tag__dot__inner {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n}\n.lz-tag__dot .lz-tag__text {\n  color: #474F64;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
